import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getNodeQueryKey, getNodesQueryKey } from 'hooks/queries/nodes';

export const useDeleteNodeMutation = (clusterId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (nodeId: string) =>
      apiClient.clusters.deleteNode({ clusterId, nodeId, forceDelete: true }),
    onSuccess: (_, nodeId) => {
      notify.success('Node deletion initiated');

      queryClient.invalidateQueries({
        queryKey: getNodesQueryKey({ clusterId }),
      });
      queryClient.invalidateQueries({
        queryKey: getNodeQueryKey({ clusterId, nodeId }),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error, 'Failed to initiate deletion'));
    },
  });
};
